/* eslint-disable */
// 1.Dependency
import { createStore } from "vuex";
import { formatDate } from "@/utils";
import { getUserConfig, updateUserConfig } from "@/service/common.js";
import { getContractPromptDay } from "@/service/contract.js";
import { getUserAssets } from "@/service/account.js";
import { getNotice } from "@/service/notice.js";
import dayjs from "dayjs";

// 2.Store
const store = {
    state: {
        latestTradingDay: sessionStorage.getItem("latestTradingDay"), // 最新交易日
        currentDate: "", // 当前选择的日期时间
        trades: [], // 交易日列表

        userConfig: null, // 用户配置

        realtime: [], // 实时数据
        promptDays: [],

        internal: 5,
        refresh: 0,

        showPaidModal: false,
        userAssets: null, // 用户资产信息

        currentContractInfo: {}, // 指定日期下的当前合约标的的价格等信息

        // 顶部notice
        notice: "",
        hideHeaderNotice: sessionStorage.getItem("hideHeaderNotice") || "0",
    },
    mutations: {
        SET_TRADING_DATE(state, date) {
            state.latestTradingDay = formatDate(date);
            sessionStorage.setItem("latestTradingDay", date);
        },
        SET_CURRENT_DATE(state, date) {
            state.currentDate = date;
        },
        SET_TRADES(state, list) {
            state.trades = list;
        },
        SET_REALTIME(state, list) {
            state.realtime = list;
        },
        SET_INTERNAL(state, val) {
            state.internal = val;
        },
        SET_REFRESH(state, val) {
            state.refresh = val;
        },
        SET_PAID_MODAL(state, val) {
            state.showPaidModal = val;
        },
        SET_CURRENT_CONTRACT_INFO(state, val) {
            state.currentContractInfo = val;
        },
        SET_HIDE_HEADER_NOTICE(state, val) {
            state.hideHeaderNotice = val;
        },
    },
    getters: {
        latestTradingDay: (state) => {
            return state.latestTradingDay;
        },
        currentDate: (state) => {
            return state.currentDate;
        },
        trades: (state) => {
            return state.trades;
        },
        promptDays: (state) => {
            return state.promptDays;
        },
        isPaid: (state) => {
            // TODO:开启付费
            return true;
            return state.userAssets && dayjs(state.userAssets.vip_0001).isAfter(dayjs());
        },
        currentContractInfo: (state) => {
            return state.currentContractInfo;
        },
        notice: (state) => {
            return state.notice;
        },
        hideHeaderNotice: (state) => {
            return state.hideHeaderNotice;
        },
    },
    actions: {
        setTradingDay({ commit }, date) {
            commit("SET_TRADING_DATE", date);
        },
        setCurrentDate({ commit }, date) {
            commit("SET_CURRENT_DATE", date);
        },
        setTrades({ commit }, list) {
            commit("SET_TRADES", list);
        },
        // 获取用户配置
        async fetchUserConfig({ state }) {
            return getUserConfig().then((response) => {
                state.userConfig = response.data.data;
                return state.userConfig;
            });
        },
        // 更新用户配置
        async updateUserConfig({ state }, data) {
            return updateUserConfig(data).then((response) => {
                return response.data.data;
            });
        },
        // 获取提示天数
        async fetchPromptDays({ state }) {
            return getContractPromptDay().then((response) => {
                state.promptDays = response.data.data?.prompt_days || [];
                return state.promptDays;
            });
        },
        // 获取用户资产
        async fetchUserAssets({ state }) {
            return getUserAssets().then((response) => {
                state.userAssets = response.data.data;
                return state.userAssets;
            });
        },
        setCurrentContractInfo({ commit }, date) {
            commit("SET_CURRENT_CONTRACT_INFO", date);
        },
        // 获取顶部notice
        async fetchHeaderNotice({ state }) {
            getNotice("fsf-fix-notice").then((res) => {
                const data = res.data.data || [];
                const notice = data?.[0]?.status == 1 ? data?.[0].content : "";
                state.notice = notice || "";
            });
        },
        setHideHeaderNotice({ commit }, val) {
            commit("SET_HIDE_HEADER_NOTICE", val);
            sessionStorage.setItem("hideHeaderNotice", val);
        },
    },
};

export default createStore(store);
